<template>
  <div class="desktron_banner">
    <a href="https://daas-personal.todesk.com/download" class="db_item2">
      <div class="db1-info">
        <p class="title">ToDesk云电脑</p>
        <div class="list-text">
          <span>高清</span><span>高性能</span><span>上千款游戏</span>
        </div>
      </div>
      <img class="db1_icon" src="@/assets/desktron/daas.svg" alt="">
    </a>
    <a href="https://www.todesk.com/mobile/#/desktron/replaceCitrix" class="db_item1">
      <div class="db1-info">
        <p class="title">Desktron云桌面</p>
        <p class="desc">思杰（Citrix）优选替代方案</p>
      </div>
      <img class="db1_icon" src="@/assets/desktron/desktron-banner.svg" alt="">
    </a>
    <a :href="item.link" class="db_item" v-for="(item,index) in list" :key="index">
      <img class="db_item_icon" :src="item.icon" alt="">
      <div class="info">
        <p class="title">{{ item.title }}</p>
        <p class="desc">{{ item.desc }}</p>
      </div>
    </a>
  </div>
</template>
<script>
export default {
  data(){
    return {
      list: [
        {
          title: '3DGali云渲染',
          desc: '专业的数字孪生云渲染服务商',
          icon: require('@/assets/desktron/3dgali.svg'),
          link: 'https://www.3dgali.com/',
        },
        {
          title: '高性能远程安全办公',
          desc: '稳定、精准、真高清远程设计',
          icon: require('@/assets/desktron/highperf.svg'),
          link:'https://www.todesk.com/mobile/#/solutions/design',
        },
      ]
    }
  },
  methods: {
    toPage(link){
      location.href = link;
    }
  },
}
</script>
<style lang="less" scoped>
.desktron_banner {
  margin-top: -55px;
  justify-content: center;
  position: relative;
  z-index: 2;
  padding-bottom: 20px;
  .db_item {
    display: flex;
    align-items: center;
    width: 335px;
    box-sizing: border-box;
    padding: 12px;
    height: 72px;
    margin: auto;
    margin-top: 14px;
    border-radius: 8px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    background: linear-gradient(180deg, #FFF 29.17%, #F3F9FF 100%);
    box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.10), 2px 3px 3px 0px rgba(255, 255, 255, 0.40) inset;
    .db_item_icon {
      width: 48px;
      height: 48px;
      margin-right: 8px;
    }
    .info {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .title {
        color: #000;
        font-family: PingFang SC;
        font-size: 16px;
        font-weight: 500;
      }
      .desc {
        color: #616369;
        font-family: PingFang SC;
        font-size: 12px;
        font-weight: 400;
      }
    }
    &:active{
      border: 1px solid #0070F9;
      background: linear-gradient(180deg, #F3F9FF 0%, #FFF 100%),rgba(17, 136, 255, 0.05);
    }
  }
  .db_item1 {
    background: #FFFFFF;
    width: 335px;
    height: 72px;
    margin: auto;
    box-sizing: border-box;
    border-radius: 8px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    background: linear-gradient(180deg, #FFF 29.17%, #F3F9FF 100%);
    box-shadow: 0px 10px 20px 0px #00000014, 0px 6px 10px 0px #FFFFFF80 inset;
    display: flex;
    justify-content: space-between;
    overflow: hidden;
    margin-top: 14px;
    .db1-info{
      padding: 15px;
      .title {
        color: #000000;
        font-family: PingFang SC;
        font-size: 16px;
        font-weight: 500;
      }
      .desc {
        margin-top: 4px;
        color: #616369;
        font-family: PingFang SC;
        font-size: 14px;
        font-weight: 400;
        white-space: nowrap;
      }
    }
    .db1_icon{
      width: auto;
      height: 100%;
    }
    &:active{
      border: 1px solid #0070F9;
      background: linear-gradient(180deg, #F3F9FF 0%, #FFF 100%),rgba(17, 136, 255, 0.05);
    }
  }
  .db_item2 {
    background: linear-gradient(93.02deg, #9254EB 0.26%, #A575EB 102.36%);
    width: 335px;
    height: 72px;
    margin: auto;
    box-sizing: border-box;
    border-radius: 8px;
    box-shadow: 0px 10px 20px 0px #00000014, 0px 6px 10px 0px #FFFFFF80;
    display: flex;
    justify-content: space-between;
    overflow: hidden;
    .db1-info{
      padding:14px 15px;
      .title {
        color: #fff;
        font-family: PingFang SC;
        font-size: 16px;
        font-weight: 500;
        height: 20px;
      }
      .list-text{
        margin-top: 4px;
        height: 20px;
        span{
          border: 1px solid #FFFFFF4D;
          padding: 2px 5px 2px 5px;
          color: #fff;
          font-size: 12px;
          margin: 0px 4px 0px 0px;
          border-radius: 4px;
        }
      }
    }
    .db1_icon{
      width: auto;
      height: 100%;
    }
    &:active{
      background: linear-gradient(0deg, rgba(255, 255, 255, 0.15) 0%, rgba(255, 255, 255, 0.15) 100%), linear-gradient(93.02deg, #9254EB 0.26%, #A575EB 102.36%);
    }
  }
}
</style>
